/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

import { html, LitElement } from 'lit-element';
import radioGroupStyles from './sh-radio-group.lit.scss.js';

/**
 * @prop {String} role - *hide
 */
export class SHRadioGroup extends LitElement {
  static get properties() {
    return {
      role: { type: String, reflect: true },
    };
  }
  static get styles() {
    return [radioGroupStyles];
  }
  render() {
    return html` <div class="radio-wrapper">
      <slot id="grouped"></slot>
    </div>`;
  }

  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'radiogroup');
    }
  }

  firstUpdated() {
    this.addEventListener('click', function (e) {
      this.handleClick(e);
    });
  }
  handleClick(e) {
    const tar = e.target;
    // If the clicked target is not disabled and not radio-group, but is a radio-button, then only toggle
    // active for child radio-buttons.
    if (!tar.disabled && tar.tagName !== 'SH-RADIO-GROUP' && tar.tagName === 'SH-RADIO-BUTTON') {
      const activeEl = this.querySelectorAll('[active]');
      for (let i = 0; i < activeEl.length; i++) {
        activeEl[i].active = false;
      }
      tar.active = true;
    }
  }
}

customElements.define('sh-radio-group', SHRadioGroup);
